import type { ChartMeasure } from "../../types/domain";

export interface Segment { chord: string | null; beats: number; time: number }

// split a measure into chord blocks: consecutive beats sharing a chord become one block,
// sized by how many beats it spans (so a mid-bar change divides the cell proportionally).
export function measureSegments(m: ChartMeasure): Segment[] {
  const segs: Segment[] = [];
  for (const b of m.beats) {
    const last = segs[segs.length - 1];
    if (last && last.chord === b.chord) last.beats++;
    else segs.push({ chord: b.chord, beats: 1, time: b.time });
  }
  return segs.length ? segs : [{ chord: null, beats: 1, time: m.startTime }];
}

/** distinct chords in order of first appearance */
export function usedChords(measures: ChartMeasure[]): string[] {
  const out: string[] = [];
  for (const m of measures) for (const b of m.beats) if (b.chord && !out.includes(b.chord)) out.push(b.chord);
  return out;
}
